// import dayjs from 'dayjs';
import { STATUS_REGISTERED_NO_ACCESS, STATUS_WAITING_CREDIT_CARD } from '@/config';

// evitar error new Date NaN en Safari & IE 
const fixDateTimeForAllBrowsers = dateString => dateString.replace(" ", "T");
const fixDateForAllBrowsersTest = dateString => dateString.replace(/-/g, '/');  //(" ", "T"); //

export const formatDateFull = (date) => new Date(fixDateTimeForAllBrowsers(date)).toLocaleString();
// "29/1/2021 9:57:51"

// const formatDate = (date) => new Date(date).toLocaleDateString();
// "29/1/2021"

export const formatTime = (date) => new Date(fixDateTimeForAllBrowsers(date)).toLocaleTimeString();
// "9:57:51"

export const formatHour = (value) => {

  let date = new Date(fixDateTimeForAllBrowsers(value))
  let hour = date.getHours()
  let minutes = date.getMinutes()
  let seconds = date.getSeconds()

  let minutos = (minutes < 10) ? '0' + minutes : minutes
  let segundos = (seconds < 10) ? '0'+ seconds : seconds

  return `${hour}:${minutos}:${segundos}`
}
//HH:mm'

// Evitar 1 cifra. Por defecto, los números de una cifra se muestran sin un cero delante
const locale = navigator.language;

export const formatDateShort = (date) => {
  const options = {day: '2-digit', month: '2-digit', year: '2-digit'};
  return new Date(fixDateTimeForAllBrowsers(date)).toLocaleDateString(locale, options);
};
// "29/01/21"

export const formatDateCustom = (date, separator = '/') => {
  const options = {day: '2-digit', month: '2-digit', year: 'numeric'};
  // replaceAll('/', separator)
  return new Date(fixDateTimeForAllBrowsers(date)).toLocaleDateString(locale, options).split('/').join(separator)
}
// "29-1-2021" // separator = '-'


export const formatDateISOCustom = (date, separator = '-') => {
  const options = {day: '2-digit', month: '2-digit', year: 'numeric'};

  let arrayDate = new Date(date).toLocaleDateString(locale, options).split('/')
  let isoDate = [ arrayDate[2], arrayDate[1], arrayDate[0] ]

  return isoDate.join(separator)
}
// "2021-05-28" // separator = '-'

export const formatDateTimeCustom = (date, separator = '/') => {
  const options = {day: '2-digit', month: '2-digit', year: 'numeric'};
  return `${new Date(fixDateTimeForAllBrowsers(date)).toLocaleDateString(locale, options).split('/').join(separator)}  ${new Date(fixDateTimeForAllBrowsers(date)).toLocaleTimeString()}`
  // "29-1-2021 9:57:51" // separator = '-'
}


export const formatDateTimeCustomTest = (date, separator = '/') => {
  const options = {day: '2-digit', month: '2-digit', year: 'numeric'};
  return `${new Date(fixDateForAllBrowsersTest(date)).toLocaleDateString(locale, options).split('/').join(separator)}  ${new Date(fixDateForAllBrowsersTest(date)).toLocaleTimeString()}`
  // "29-1-2021 9:57:51" // separator = '-'
}


export const todayISODate = () => new Date().toISOString().slice(0, 10);
// 2021-05-28

export const formatISODateTime = (date) => {
  return `${new Date(fixDateTimeForAllBrowsers(date)).toISOString().slice(0, 10)}  ${new Date(fixDateTimeForAllBrowsers(date)).toLocaleTimeString()}`
  // "2021-05-28 9:57:51"
}

export const formatISODate = (date) => {
  return new Date(fixDateTimeForAllBrowsers(date)).toISOString().slice(0, 10)
  // "2021-05-28 9:57:51"
}

// los meses van de 0(enero) a 11(diciembre)
export const getFirstDayOfMonth = (year, month) => {
  return new Date(year, month, 1);
}

// [yourKeyVariable]: someValueArray, add key to an object

export const now = () => Date.now();

export const formatDateToString = (date, separator = '-') => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 a 11
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}${separator}${month}${separator}${day}`;
};


const calculateFullDays24h = (startDate, endDate) => {
  // Convertir a objetos Date
  const start = new Date(startDate);
  const end = new Date(endDate);

  // Asegurar que el inicio y el final tengan los segundos y minutos configurados
  start.setSeconds(0, 0); // Forzar segundos y milisegundos a 0
  end.setSeconds(59, 999); // Forzar segundos y milisegundos a 59 y 999

  // Ajustar el inicio al día siguiente si no empieza a las 00:00:00
  if (start.getHours() !== 0) {
    start.setHours(0, 0, 0, 0);
    start.setDate(start.getDate() + 1);
  }

  // Ajustar el final al día anterior si no termina a las 23:59:59
  if (end.getHours() !== 23) {
    end.setHours(23, 59, 59, 999);
    end.setDate(end.getDate() - 1);
  }

  // Calcular la diferencia en milisegundos
  const differenceInMilliseconds = end - start;

  // Convertir la diferencia a días completos de 24 horas
  const fullDays = Math.max(0, Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24)));

  return fullDays;
};


// Deep clone
// Cuidado: si el objeto que le pasemos tiene alguna función, no se copiará.
export const clone = (obj) => JSON.parse(JSON.stringify(obj));


// Formatear números
/**
 * Al igual que con las fechas, nos interesa convertir los números según dónde se encuentren nuestros usuarios.
 * Así, podremos mostrar separadores de miles y de decimales con puntos o comas sin preocuparnos.
 */
export const formatNum = (num) => Intl.NumberFormat().format(num);
// 12345.6789 --> "12.345,678"

// const locale = 'en';
// const options = { style: 'currency', currency: 'GBP', maximumFractionDigits: 2};
// const formatNum = (num) => {
//   return Intl.NumberFormat(locale, options).format(num);
// };
// 12345.6789 --> "£12,345.68


export const toFixedNoRounding = (value, decimals) => {

  const n = decimals;
  const reg = new RegExp("^-?\\d+(?:\\.\\d{0," + n + "})?", "g")
  const a = value.toString().match(reg)[0];
  const dot = a.indexOf(".");
  if (dot === -1) { // integer, insert decimal dot and pad up zeros
      return a + "." + "0".repeat(n);
  }
  const b = n - (a.length - dot) + 1;
  const result =  b > 0 ? (a + "0".repeat(b)) : a;
  return result.replace('.', ',')

}


export const multiselectFormat = ({ label, value }) => {
  return {
    label: label,
    value: value
  }
}


/*

  1 Base
  2 24h. Hora libre
  3 Noche / 2 días / 8pm - 9am.  /// DESCARTADO
  4 Fin de semana. / 3 días /  Viernes desde 15h S-D 24h
  5 Cuatro días. / 4 días / Hora libre
  6 Siete días. / 7 días / Hora y días libre
  7 Semanal ejecutivo / 7 días /   /// DESCARTADO
  8 Mensual Ejecutivo / 30 días / L-V 8am - 6pm. 
  9 Mensual Noche.  / 30 días / L-V 8pm - 9am. S-D 24h
  10 Mensual. 30 días / Hora libre

*/

export const getDurationPlanByID = (planId) => {
  // duración de un plan en días
  const PLAN_DURATION = {
    2 : 1,
    3: 1,
    4: 3,
    5: 4,
    6: 7,
    7: 5,
    8: 30,
    9: 30,
    10: 30
  }
  const DEFAULT = 1;

  return PLAN_DURATION[planId] || DEFAULT
}

export const getPlanDetailHours = (planId) => {

  const PLAN_HOURS_DETAIL = {
    1: 'Elige cuando entrar y salir', // Base
    2: 'Elige el día y hora de inicio. 24h' ,
    3: '',
    4: 'Desde el Viernes a las 15h, Sábado y Domingo de 00h a 23h',
    5: '4 días consecutivos, elige el día y hora de inicio',
    6: '',
    7: '',
    8: 'De Lunes a Viernes de 8h a 18h. 30 días', //
    9: 'De Lunes a Viernes de 20h a 9h, Sábado y Domingo de 00h a 23h. 30 días', //
    10: 'Elige el día y hora de inicio. 30 días', 
    11: 'Elige el día, hora de inicio y la duración. Adaptado a ti', // Libre
  }
  const DEFAULT = 'Elige el día de inicio que se adapte mejor a ti';

  return PLAN_HOURS_DETAIL[planId] || DEFAULT

}


export const getExpirationDate = (card) => {
  const today = new Date();
  const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
  const todayArray = today.toLocaleDateString("es-ES", options).split('/');  // 21/1/2021

  const mes = +todayArray[1];
  const anyo = todayArray[2];

  let data = {
    date: '',
    is_expirated: false
  };

  let month = mes;
  let fullYear = anyo;

  if (card.expiration_date) {   // 2022 / 2022/05

    if (card.expiration_date.length > 4) {
      fullYear = card.expiration_date.split('/')[0];
      month = card.expiration_date.split('/')[1];

    } else {
      const year = card.expiration_date.substr(0,2);
      fullYear = anyo.substr(0,2) + year;
      month = card.expiration_date.substr(2,2);
    }

    if ( mes > +month && +anyo >= +fullYear || +anyo > +fullYear ) {
      data.is_expirated = true;
    }

    data.date += `${month}/${fullYear}`

  } else {
    data.date = "Tarjeta validada"
  }

  return data;
}

export const getCardLast4 = (value) => {
  if (value && value.last4) {
    return value.last4.length > 4 ?
    '***' + value.last4.slice(value.last4.length - 4)
      : value.last4 ? '***' + value.last4 : 'Tarjeta validada';
  }else {
    return 'Tarjeta validada'
  }
}
export const generateMapsUrl = (parking) => {
  const urlSuffix = parking['name'] ? parking['name'] :
     `${parking['latitude']},${parking['longitude']}`;

  return 'https://www.google.com/maps/search/?api=1&query=' + urlSuffix;
}

export const openGoogleMaps = (parking) => {
  let url = generateMapsUrl(parking);

  if (parking.google_maps) {
    url = parking.google_maps;
  } 

  window.open(url, '_blank');
}


export const Random50Percent = () => {
  return Math.random() < 0.5;
}

export const getDetailPlanDate = (plan) => {

  // start_hour: "00:00"
  // end_hour: "23:59"

  // start_day: "Sabado" //
  // end_day: "Domingo" //

  // duration: 2

  // renewal: false
  // renewal_limit_days: 1

  /*
  id Plan

  1. Base

  2. 24h -> 1
  3. Noche -> 1   ( 8pm - 9am)
  4. finde -> 3
  5. Pack4 -> 4

  6. Semanal -> 7
  7. Semanal Ejecutivo -> 5   L-V ( 8am - 6pm)

  8. Mensual Ejecutivo -> 5 / mes   L-V ( 8am - 6pm)  moment().add(1, 'day') - moment().add(1, 'month'));
  9. Mensual Noche -> 30 / 31 / 28 ( 8pm - 9am)
  10. Mensual -> 30 / 31 / 28

  */

}

export const noPhone = (client)  => {
  // if (client)
  //   return Boolean(client.phone_verified)
  // return true

  if (client)
    return !Boolean(client?.phone) || !Boolean(client.phone_verified)
  return false
};

export const noEmail = (client) => {

  // if (client) 
  //   return Boolean(client?.email_verified_at);
  // return true

  if (client)
    return !Boolean(client?.email_verified)
  return false
}

export const noParkingAccess = (client) => {
  // ? Status viene como NEW al registrarse.
  if (client)
    return [STATUS_REGISTERED_NO_ACCESS, STATUS_WAITING_CREDIT_CARD].includes(client?.status);
  return false
}

export const noCreditCard = (client) => {
  // if (client && client.credit_cards)
  //   return client?.credit_cards?.length > 0
  // return true

  if (client) {
    if (client?.credit_cards)
      return client.credit_cards.length == 0
    return true
  } else {
    return false
  }

}